import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, TextField, Button, Grid, InputLabel, FormControl, Input, FormHelperText } from '@mui/material';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const FacturacionConfig: React.FC = () => {
  const [cuit, setCuit] = useState('');
  const [nombre, setNombre] = useState('');
  const [matricula, setMatricula] = useState('');
  const [puntoVenta, setPuntoVenta] = useState('');
  const [certificado, setCertificado] = useState<File | null>(null);
  const [clavePrivada, setClavePrivada] = useState<File | null>(null);
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/facturacion-config/`);
      if (res.data) {
        setCuit(res.data.Cuit || '');
        setNombre(res.data.Nombre || '');
        setMatricula(res.data.Matricula || '');
        setPuntoVenta(res.data.PuntoVenta || '');
      }
    } catch (e) {
      // No config yet
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('cuit', cuit);
    formData.append('nombre', nombre);
    formData.append('matricula', matricula);
    formData.append('punto_venta', puntoVenta);
    if (certificado) formData.append('certificado', certificado);
    if (clavePrivada) formData.append('clave_privada', clavePrivada);
    try {
      await axios.post(`${API_BASE_URL}/facturacion-config/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setMensaje('Configuración guardada correctamente.');
    } catch (e) {
      setMensaje('Error al guardar la configuración.');
    }
  };

  return (
    <Box sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>Configuración de Facturación</Typography>
      <Paper sx={{ p: 3 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField label="CUIT" value={cuit} onChange={e => setCuit(e.target.value)} fullWidth required />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Nombre/Razón social" value={nombre} onChange={e => setNombre(e.target.value)} fullWidth required />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Matrícula" value={matricula} onChange={e => setMatricula(e.target.value)} fullWidth required />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Punto de venta" value={puntoVenta} onChange={e => setPuntoVenta(e.target.value)} fullWidth required />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="certificado">Certificado digital (.crt)</InputLabel>
                <Input id="certificado" type="file" inputProps={{ accept: '.crt' }} onChange={e => setCertificado((e.target as HTMLInputElement).files?.[0] || null)} />
                <FormHelperText>Subí tu archivo .crt</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="clave_privada">Clave privada (.key)</InputLabel>
                <Input id="clave_privada" type="file" inputProps={{ accept: '.key' }} onChange={e => setClavePrivada((e.target as HTMLInputElement).files?.[0] || null)} />
                <FormHelperText>Subí tu archivo .key</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="primary" fullWidth>Guardar configuración</Button>
            </Grid>
            {mensaje && (
              <Grid item xs={12}>
                <Typography color={mensaje.includes('Error') ? 'error' : 'success.main'}>{mensaje}</Typography>
              </Grid>
            )}
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};

export default FacturacionConfig; 